export default function inittabs() {
  const tabHeaders = document.querySelectorAll(".tab_header li");

  // Add click event to each tab header
  tabHeaders.forEach((tab) => {
    tab.addEventListener("click", function () {
      // Remove active class from all tabs
      tabHeaders.forEach((t) => t.classList.remove("tab-active"));

      // Add active class to clicked tab
      this.classList.add("tab-active");

      // Get the tab content ID from data attribute
      const tabId = this.getAttribute("data-tab");

      // Hide all tab content
      const tabContents = document.querySelectorAll(".tab_item");
      tabContents.forEach((content) => content.classList.remove("active"));

      // Show the selected tab content
      document.getElementById(tabId).classList.add("active");
    });
  });
}
